<template>
  <div class="pop-payment-wrap">
    <div class="pop-header">
      <span class="pop-title">반품</span>
      <button class="btn-pop-close" @click="$.emit('close')">
        닫기<span class="overlay"></span>
      </button>
    </div>
    <div class="pop-body">
      <div class="fieldset">
        <span class="h2">반품정보</span>
        <div class="ip-row col04">
          <label for="rtNum01">점포번호</label>
          <input type="text" class="ip-comm center" id="rtNum01" value="0000" />
          <label for="rtNum02">매장번호</label>
          <input type="text" class="ip-comm center" id="rtNum02" value="00" />
        </div>
        <div class="ip-row col04">
          <label for="date">매출일자</label>
          <Datepicker
            v-model="date"
            :style="pickerStyle"
            class="datepicker startDate ip-comm center"
          ></Datepicker>
          <label for="rtNum03">포스번호</label>
          <input type="text" class="ip-comm center" id="rtNum03" value="0004" />
        </div>
        <div class="ip-row col04 fl-l">
          <label for="rcNum">영수증번호</label>
          <input type="text" class="ip-comm center" id="rcNum" value="000000" />
          <button
            type="button"
            class="btn-smd btn-main"
            style="margin-left: 0.5em"
            @click="search"
          >
            조회<span class="overlay"></span>
          </button>
        </div>
      </div>
      <div class="flex">
        <table class="tb-lst-payment tb-return">
          <thead>
            <tr>
              <td>No.</td>
              <td>결제수단</td>
              <td>금액</td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(receipt, i) in receiptList
                .filter((item) => item.receiptDate == date2)
                .filter((item) => item.type != 'RCP002')"
              :key="receipt"
              :class="{ on: selectIdx == receipt.receiptIdx }"
              @click="selectIdx = receipt.receiptIdx"
            >
              <td>{{ lpad(i + 1, 4, "0") }}</td>
              <td>{{ receipt.payType == "PAY001" ? "신용" : "현금" }}</td>
              <td>
                {{
                  receipt.amount
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }}
              </td>
            </tr>
          </tbody>
        </table>
        <div class="tb-side-btn">
          <button type="button" class="btn-side-up" disabled>
            위로<span class="overlay"></span>
          </button>
          <button type="button" class="btn-side-down" disabled>
            아래로<span class="overlay"></span>
          </button>
        </div>
      </div>
    </div>
    <div class="pop-btn-area">
      <!-- [팝업버튼 크기] .btn-pop: 100%, .btn-pop.btn-half: 50%, .btn-pop.btn-third: 33.33%, .btn-pop.btn-fourth: 25% -->
      <button
        type="button"
        class="btn-pop btn-half btn-submit"
        @click="reOrder"
      >
        반품<span class="overlay"></span>
      </button>
    </div>

    <PopupBtn1
      style="position: static"
      v-if="isPopupBtn1"
      :popupText="popupText"
      :popupTitle="popupTitle"
      @close="isPopupBtn1 = false"
    />
  </div>
</template>

<script>
import jsonReceiptList from "@/assets/json/ReceiptList.js";
import Datepicker from "vue3-datepicker";
import popupBtn1 from "@/components/popup/PopupBtn1.vue";

export default {
  name: "cardPayment",
  props: {},
  data() {
    return {
      receiptList: jsonReceiptList.data.receiptList,
      selectIdx: 0,
      isPopupBtn1: false,
      popupText: "",
      popupTitle: "",
      pickerStyle: {
        height: "40px",
        "font-weight": "bold",
        outline: "1px solid #5E6877",
        border: "1px solid #fff",
        "border-radius": "4px",
        "font-size": "16px",
        textAlign: "center",
        width: "120px",
      },
      date: new Date(),
      date2: "",
    };
  },
  methods: {
    reOrder() {
      if (
        this.receiptList.filter((item) => item.receiptIdx == this.selectIdx)
          .length == 0
      )
        return;
      let reorder = this.receiptList.filter(
        (item) => item.receiptIdx == this.selectIdx
      )[0];
      reorder.type = "RCP002";
      this.popupTitle = "반품";
      this.popupText = "반품 되었습니다.";
      this.isPopupBtn1 = true;
    },
    search() {
      let year = this.date.getFullYear();
      let month = ("0" + (this.date.getMonth() + 1)).slice(-2); // 월은 0부터 시작하기 때문에 +1이 필요하며, 항상 두 자리를 유지하기 위해 slice를 사용합니다.
      let day = ("0" + this.date.getDate()).slice(-2); // 일도 항상 두 자리를 유지하기 위해 slice를 사용합니다.

      this.date2 = year + "-" + month + "-" + day;
    },
    lpad(str, padLen, padStr) {
      str += ""; // 문자로
      padStr += ""; // 문자로
      while (str.length < padLen) str = padStr + str;
      str = str.length >= padLen ? str.substring(0, padLen) : str;
      return str;
    },
  },
  watch: {},
  computed: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  unmounted() {},
  components: {
    Datepicker,
    PopupBtn1: popupBtn1,
  },
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped></style>


